<template>
    <div>
        <zm-row>
            <zm-button @click="showCreate" type="primary" plain>Create Menu</zm-button>
            <zm-button @click="showBatchCreate" type="primary" plain>Batch Create Menu</zm-button>
        </zm-row>
        <div class="table-container">
        <zm-table :data="menuList" :row-key="getRowKeys" v-loading="loading" default-expand-all>
            <zm-table-column prop="name" label="Collection Name"></zm-table-column>
            <zm-table-column prop="description" label="Description"></zm-table-column>
            <zm-table-column prop="path" label="Path"></zm-table-column>
            <zm-table-column width="120px">
                <template slot-scope="scope">
                    <zm-button type="icon" icon="zm-icon-edit" @click="showEdit(scope.row)"></zm-button>
                    <zm-button type="icon" icon="zm-icon-delete" @click="showDelete(scope.row.id)"></zm-button>
                </template>
            </zm-table-column>
        </zm-table>
        <div class="pagination-wrap"></div>
        </div>
        <zm-dialog :visible.sync="visible" :title="form.title">
            <zm-form label-width="120px" :model="form" ref="form" :rules="rules">
                <zm-form-item prop="name">
                    <div slot="label">
                        <tip label="Name" id="permission-menu-name"></tip>
                    </div>
                    <zm-input v-model="form.name"></zm-input>
                </zm-form-item>
                <zm-form-item prop="description">
                    <div slot="label">
                        <tip label="Description" id="permission-menu-description"></tip>
                    </div>
                    <zm-input v-model="form.description"></zm-input>
                </zm-form-item>
                <zm-form-item label="path" prop="path">
                    <div slot="label">
                        <tip label="Path" id="permission-menu-path"></tip>
                    </div>
                    <zm-input v-model="form.path"></zm-input>
                </zm-form-item>
                <zm-form-item>
                    <div slot="label">
                        <tip label="Parent" id="permission-menu-parent"></tip>
                    </div>
                    <zm-select v-model="form.parentId" filterable clearable style="width: 100%">
                        <zm-option v-for="item in menuList" :key="item.id" :value="item.id" :label="item.name" :disable="item.id === form.id"></zm-option>
                    </zm-select>
                </zm-form-item>
                <zm-form-item>
                    <div slot="label">
                        <tip label="Action" id="permission-menu-actions"></tip>
                    </div>
                    <zm-checkbox-group v-model="form.menuOptions">
                        <zm-checkbox v-for="(item, index) in ['C', 'U', 'R', 'D']" :key="index" :value="item" :label="item"></zm-checkbox>
                    </zm-checkbox-group>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button @click="visible = false">Cancel</zm-button>
                <zm-button @click="save" type="primary" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
        <zm-dialog title="Batch Create Menu" :visible.sync="batchVisible">
            <zm-form>
                <zm-form-item>
                    <zm-input type="textarea" v-model="statementMenuParamList"></zm-input>
                </zm-form-item>
            </zm-form>
            <div slot="footer">
                <zm-button size="small" @click="batchVisible = false">Cancel</zm-button>
                <zm-button size="small" type="primary" @click="batchCreateStatementMenu()" :loading="loading">Submit</zm-button>
            </div>
        </zm-dialog>
    </div>
</template>
<script>
import { getAllStatementMenus, createStatementMenu, editStatementMenu, deleteStatementMenu, batchCreateStatementMenu } from '@/api/statement'
import tip from '@/components/ToolTip/index'
export default {
    name: 'developerPermission',
    components: { tip },
    data () {
        return {
            loading: false,
            menuList: [],
            form: {
                id: '',
                title: '',
                name: '',
                description: '',
                path: '',
                parentId: '',
                menuOptions: []
            },
            visible: false,
            batchVisible: false,
            statementMenuParamList: '',
            getRowKeys (row) {
                return row.id
            },
            rules: {
                name: [
                    { required: true, message: 'please input name', trigger: 'blur' }
                ]
            }
        }
    },
    created () {
        this.fetchData()
    },
    methods: {
        fetchData () {
            this.loading = true
            getAllStatementMenus().then(response => {
                this.menuList = response
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showBatchCreate () {
            this.batchVisible = true
            this.statementMenuParamList = ''
        },
        batchCreateStatementMenu () {
            this.loading = true
            batchCreateStatementMenu(this.statementMenuParamList).then(response => {
                this.batchVisible = false
                this.$message.success('Batch create success')
                this.loading = false
            }).catch(() => {
                this.loading = false
            })
        },
        showCreate () {
            this.form.title = 'Create Menu'
            this.form.id = ''
            this.form.name = ''
            this.form.path = ''
            this.form.parentId = ''
            this.form.description = ''
            this.form.menuOptions = []
            this.visible = true
        },
        showEdit (row) {
            this.form.title = 'Edit Menu'
            this.form.id = row.id
            this.form.name = row.name
            this.form.description = row.description
            this.form.parentId = row.parentId
            this.form.path = row.path
            this.form.menuOptions = row.menuOptions
            this.visible = true
        },
        save () {
            this.$refs.form.validate((valid) => {
                if (valid) {
                    const {
                        title,
                        id,
                        name,
                        description,
                        path,
                        parentId,
                        menuOptions
                    } = this.form
                    const data = {
                        name,
                        description,
                        path,
                        parentId,
                        menuOptions
                    }
                    if (title === 'Create Menu') {
                        this.loading = true
                        createStatementMenu(data).then(response => {
                            this.visible = false
                            this.$message.success('Create success')
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    } else {
                        this.loading = true
                        editStatementMenu(id, data).then(response => {
                            this.visible = false
                            this.$message.success('Update success')
                            this.fetchData()
                        }).catch(() => {
                            this.loading = false
                        })
                    }
                }
            })
        },
        showDelete (id) {
            this.$confirm('This will delete menu. Continue?', 'Warning', {
                confirmButtonText: 'Delete',
                cancelButtonText: 'Cancel',
                type: 'warning'
            }).then(() => {
                this.loading = true
                deleteStatementMenu(id).then(response => {
                    this.fetchData()
                    this.$message.success('Delete success!')
                }).catch(() => {
                    this.loading = false
                })
            }).catch(() => {
                this.$message.info('Delete canceled')
            })
        }
    }
}
</script>
